import * as TabsPrimitive from '@radix-ui/react-tabs'
import { type ComponentProps, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

function Tabs (props: ComponentProps<typeof TabsPrimitive.Root>): ReactElement {
  return <TabsPrimitive.Root {...props} />
}

function TabsList ({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>): ReactElement {
  return (
    <TabsPrimitive.List
      className={cn('inline-flex items-center gap-1 border-b border-(--bp-border)', className)}
      {...props}
    />
  )
}

function TabsTrigger ({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>): ReactElement {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'px-4.5 h-13 text-[13px] font-medium text-(--bp-ink3) border-none border-b-2 border-transparent -mb-px bg-none cursor-pointer whitespace-nowrap transition-colors',
        'hover:text-(--bp-ink2) data-[state=active]:text-(--bp-accent) data-[state=active]:border-(--bp-accent) data-[state=active]:font-semibold',
        className
      )}
      {...props}
    />
  )
}

function TabsContent ({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>): ReactElement {
  return <TabsPrimitive.Content className={cn('outline-none', className)} {...props} />
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
